interface GTMEvent {
  event: string;
  [key: string]: any;
}

export const useGTM = () => {
  const pushEvent = (event: string, data: Record<string, any> = {}) => {
    const gtmEvent: GTMEvent = {
      event,
      ...data
    };

    if (window.dataLayer) {
      window.dataLayer.push(gtmEvent);
    }
  };

  return { pushEvent };
};

export default useGTM; 